const { getElement, getElements } = window.BAO.Utils

class ProductAsVariant extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['radio']
  }

  setupListeners () {
    super.setupListeners()

    this.handleChange = this.handleChange.bind(this)
    this.handleUnselectedVariant = this.handleUnselectedVariant.bind(this)

    this.els.radio?.elements?.forEach(radioEl => {
      this.listeners.add(radioEl, 'change', this.handleChange)
    })

    this.addToCartEl.addEventListener(
      'click',
      this.handleUnselectedVariant,
      true,
    )

    this.wishlistEls.forEach(wishlistEl => {
      wishlistEl.addEventListener('click', this.handleUnselectedVariant, true)
    })

    this.externalWishlistEls.forEach(wishlistEl => {
      wishlistEl.addEventListener('click', this.handleUnselectedVariant, true)
    })
  }

  handleUnselectedVariant (event) {
    const hasCheckedRadio = this.els.radio?.elements?.some(
      radioEl => radioEl.checked,
    )

    if (hasCheckedRadio) return

    event.preventDefault()
    event.stopImmediatePropagation()

    this.showErrorMessage('Please select size')
  }

  handleChange (event) {
    const currentRadioEl = event.target
    const labelEl = currentRadioEl.closest('label')

    if (!labelEl) return

    this.els.radio.elements.forEach(radioEl => {
      radioEl.closest('label')?.setAttribute('aria-current', 'false')
    })

    labelEl.setAttribute('aria-current', 'true')

    this.updateElements(currentRadioEl)

    document.querySelector('body').classList.remove('util-SelectVariant')
    document.querySelector(
      '.prd-Detail_Quantity .qty-Adjuster_Input',
    ).dataset.shouldBeDisabled = 'false'
    document.querySelector(
      '.prd-Detail_Quantity .qty-Adjuster_Control-plus',
    ).dataset.shouldBeDisabled = 'false'

    this.removeErrorMessages()
  }

  updateElements (currentRadioEl) {
    this.idInputEls?.forEach(
      idInputEl => (idInputEl.value = currentRadioEl.value),
    )

    this.quantityLimitEls?.forEach(quantityLimitEl => {
      quantityLimitEl.setAttribute(
        'available',
        currentRadioEl?.dataset?.available,
      )
      quantityLimitEl.setAttribute(
        'inventory-policy',
        currentRadioEl?.dataset?.inventoryPolicy,
      )
      quantityLimitEl.setAttribute(
        'inventory-quantity',
        currentRadioEl?.dataset?.inventoryQuantity,
      )
    })

    this.lowStockEls?.forEach(lowStockEl => {
      lowStockEl.setAttribute('available', currentRadioEl?.dataset?.available)
      lowStockEl.setAttribute(
        'inventory-policy',
        currentRadioEl?.dataset?.inventoryPolicy,
      )
      lowStockEl.setAttribute(
        'inventory-quantity',
        currentRadioEl?.dataset?.inventoryQuantity,
      )
    })

    this.pdpWishlistEls.forEach(wishlistEl => {
      wishlistEl.setAttribute(
        'data-product-id',
        currentRadioEl?.dataset?.productId,
      )
      wishlistEl.setAttribute(
        'data-variant-id',
        currentRadioEl?.dataset?.variantId,
      )
    })

    this.quantityEls?.forEach(quantityEl => {
      quantityEl.setAttribute('max', currentRadioEl?.dataset?.inventoryQuantity)
    })

    if (this.addToCartEl) {
      this.addToCartEl.setAttribute(
        'aria-hidden',
        currentRadioEl?.dataset?.available !== 'true',
      )
    }

    if (this.soldOutEl) {
      this.soldOutEl.setAttribute(
        'aria-hidden',
        currentRadioEl?.dataset?.available === 'true',
      )
      this.soldOutEl.disabled = currentRadioEl?.dataset?.available === 'true'
    }
  }

  removeErrorMessages () {
    document
      .querySelectorAll('.prd-DetailForm_VariantErrorMsg')
      .forEach(el => el.remove())
  }

  createErrorMessage (message) {
    const el = document.createElement('div')
    el.className = 'prd-DetailForm_VariantErrorMsg fz-12_18'
    el.textContent = message
    return el
  }

  showErrorMessage (message) {
    // Remove existing error message if any
    this.removeErrorMessages()

    // Append error message after the ATC button
    this.addToCartEl.insertAdjacentElement(
      'beforebegin',
      this.createErrorMessage(message),
    )

    // Append message to mobile ATC button if it is visible.
    if (this.clothingSizesModalTriggerEl?.offsetParent !== null) {
      this.clothingSizesModalTriggerEl.insertAdjacentElement(
        'afterend',
        this.createErrorMessage(message),
      )

      this.clothingSizesModalTriggerEl.scrollIntoView({ behavior: 'smooth' })
      this.clothingSizesModalTriggerEl.focus()
    }

    if (this.clothingSizesVariants) {
      this.clothingSizesVariants.insertAdjacentElement(
        'afterend',
        this.createErrorMessage(message),
      )
    }
  }

  get contextEl () {
    return getElement('[data-product-detail-blocks]')
  }

  get idInputEls () {
    return getElements('form[action*="/cart/add"] [name="id"]', {
      context: this.contextEl,
    })
  }

  get quantityLimitEls () {
    return getElements('product-quantity-limit', { context: this.contextEl })
  }

  get lowStockEls () {
    return getElements('product-low-stock', { context: this.contextEl })
  }

  get externalWishlistEls () {
    const els = getElements('[is="wishlist-heart"]', {
      context: document.body,
    })

    return Array.from(els).filter(el => !this.wishlistEls.includes(el))
  }

  get wishlistEls () {
    return getElements('[is="wishlist-heart"]', { context: this.contextEl })
  }

  /**
   * Every heart for the product this PDP sells: the media button (it sits in
   * the media column, outside every other context here, so without it a size
   * selection would leave it pointed at the parent product), the desktop form
   * hearts (in stock and sold out) and the mobile form hearts. Hearts outside
   * these contexts (cart drawer, recommendations, product cards) belong to
   * other products and keep their own ids.
   */
  get pdpWishlistEls () {
    const els = [
      ...getElements(
        '[is="wishlist-heart"][data-clothing-sizes-wishlist-button]',
      ),
      ...this.wishlistEls,
      ...getElements(
        '[data-product-detail-blocks-mobile] [is="wishlist-heart"]',
      ),
    ]

    return [...new Set(els)]
  }

  get quantityEls () {
    return getElements('[name="quantity"]', { context: this.contextEl })
  }

  get addToCartEl () {
    return getElement('button[data-product-add-to-cart]', {
      context: this.contextEl,
    })
  }

  get wishlistEl () {
    return getElement('button[data-product-wishlist]', {
      context: this.contextEl,
    })
  }

  get soldOutEl () {
    return getElement('button[data-product-sold-out]', {
      context: this.contextEl,
    })
  }

  get clothingSizesVariants () {
    return getElement('[data-clothing-sizes-modal-el="variants"]')
  }

  get clothingSizesModalTriggerEl () {
    return getElement('[data-clothing-sizes-modal-el="trigger"]')
  }

  get minusQtyEl () {
    return getElements('data-quantity-adjuster-el="minus"', {
      context: this.contextEl,
    })
  }
}

if (!window.customElements.get('product-as-variant')) {
  window.customElements.define('product-as-variant', ProductAsVariant)
}
